module.exports = __webpack_public_path__ + "static/media/chevron-right-solid.0b2c7bfa.svg";